import React, { FC, ReactNode } from 'react';
import { useTheme } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

interface Props {
  label: ReactNode;
  value: ReactNode;
}

export const AbsenceDetailsRow: FC<Props> = ({ label, value }) => {
  const theme = useTheme();

  return (
    <TableRow sx={{ fontSize: '0.875rem' }}>
      <TableCell
        sx={{
          color: theme.palette.text.secondary,
          verticalAlign: 'top',
          whiteSpace: 'pre',
          paddingLeft: 0,
          width: '25%',
        }}
      >
        {label}
      </TableCell>
      <TableCell colSpan={4}>{value}</TableCell>
    </TableRow>
  );
};
